import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import './detailTalent.css';
import ActionButtons from '../../../commun/ActionButtons';
import CustomAlert from '../../../commun/CustomAlert';

const CvViewer = ({ 
  talent, 
  apiBase,
  editableTalent,
  originalTalent,
  setEditableTalent,
  onSave,
  onFieldChange,
 }) => {
  const [cvBlobUrl, setCvBlobUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const cvFilename = talent?.cvUpload;
  const [isEditing, setIsEditing] = React.useState(false);
  const [selectedCvFile, setSelectedCvFile] = useState(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('success');

  useEffect(() => {
    const fetchCV = async () => {
      if (!cvFilename) return;

      setLoading(true);
      try {
        const response = await fetch(`${apiBase}/api/recruteur/uploads/${cvFilename}`);
        if (!response.ok) throw new Error('CV introuvable');

        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        setCvBlobUrl(url);
      } catch (err) {
        console.error('Erreur chargement CV:', err);
        setError('Impossible de charger le CV.');
      } finally {
        setLoading(false);
      }
    };

    fetchCV();

    return () => {
      if (cvBlobUrl) {
        URL.revokeObjectURL(cvBlobUrl);
      }
    };
  }, [cvFilename, apiBase]);

  const handleEdit = () => setIsEditing(true);

  const handleCancel = () => {
    setEditableTalent(originalTalent);
    setIsEditing(false);
  };

  const handleSave = async () => {
    try {
      if (selectedCvFile) {
        const formData = new FormData();
        formData.append('cv', selectedCvFile);
        formData.append('talentId', editableTalent?._id); 
        formData.append('recruteurId', localStorage.getItem('userId'));
        const response = await fetch(`${apiBase}/api/recruteur/update-cv/${editableTalent?._id}`, {
          method: 'PUT',
          body: formData,
        });
  
        const result = await response.json();
        if (!response.ok) throw new Error(result.message || 'Échec de la mise à jour du CV');
  
        onFieldChange('cvUpload', result.filename); 
      }
  
      await onSave();
      setIsEditing(false);
      setSelectedCvFile(null);
    } catch (err) {
      setAlertMessage('Ce CV est déjà utilisé par un autre talent');
      setAlertSeverity("error");
      setAlertOpen(true);
    }
  };
  

  return (
    <Paper elevation={3} className="paper-box">
     <CustomAlert
        open={alertOpen}
        message={alertMessage}
        severity={alertSeverity}
        onClose={() => setAlertOpen(false)}
      />
      <Box className="top-right-buttons">
        <ActionButtons
            isEditing={isEditing}
            onEdit={handleEdit}
            onCancel={handleCancel}
            onSave={handleSave}
            showView={false}
            showDelete={false}
            showDownload={false}
          />
        </Box>
      <Typography variant="h6" gutterBottom>CV du talent</Typography>
        {isEditing ? (
          <Box>
            <Typography variant="body1">Sélectionnez un fichier CV (PDF) :</Typography>
            <input
              type="file"
              accept=".pdf"
              onChange={(e) => setSelectedCvFile(e.target.files[0])}
            />
            {selectedCvFile && (
              <Typography variant="body2">Fichier sélectionné : {selectedCvFile.name}</Typography>
            )}
          </Box>
        ) : (
          cvBlobUrl && (
            <iframe
              src={cvBlobUrl}
              title="CV du Talent"
              className="iframe-cv"
            />
          )
        )}

      {loading && <Typography>Chargement du CV...</Typography>}
      {error && <Typography className="error-text">{error}</Typography>}
    </Paper>
  );
};

export default CvViewer;
